export const CURRENCY_EUR = "CURRENCY_EUR";
export const PERCENTAGE = "PERCENTAGE";
